import { Link, useNavigate } from "react-router-dom";
import { EventCreatePanel } from "../../../components/admin/event-hub/EventOverviewPanel";

export function AdminEventNewPage() {
  const navigate = useNavigate();

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <Link to="/admin/events" className="admin-event-hub-back">
          ← All events
        </Link>
        <h1>Schedule event</h1>
        <p>Create a new worship overnight. You can add stream, album, and registration from the event hub after saving.</p>
      </header>
      <EventCreatePanel onCreated={(id) => navigate(`/admin/events/${id}/overview`, { replace: true })} />
    </div>
  );
}
